import { useState } from "react";
import api from "../api/PosApi";
import { isTokenValid } from "../utils/auth";
import { CButton } from "@coreui/react";
import { CForm, CFormInput, CAlert } from "@coreui/react";
import logo from "../assets/img/Full4_colors.png";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export default function Login({ onLogin }: { onLogin: () => void }) {
  const [nit, setNit] = useState("");
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      if(!nit || !usuario || !password){
        setError("¡Debes completar todos los campos!");
        return;
      }
      const res = await api.post("/pos/login", { nit, usuario, password });
      const token = res.data.token;
      localStorage.setItem("username", res.data.usuario);
      if (isTokenValid(token)) {
        localStorage.setItem("token", token);
        onLogin();
      } else {
        setError("Token inválido o expirado");
      }
    } catch {
      MySwal.fire({
                icon: "error",
                title: "Error de Autenticación",
                text: `Credenciales invalidas. Valida nuevamente tus datos, si no contacta a soporte.`,
                timer: 2500,
                showConfirmButton: false,
            });
    }
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center min-vh-100 text-light"
    >
      <div className="p-5 rounded shadow" style={{ background: "rgb(32, 32, 37)" }}>
        {/* Logo grande al centro */}
        <div className="mb-3 text-center">
          <img
            src={logo}
            alt="LOGPOSE"
            style={{ width: "200px", opacity: 0.95 }}
          />
        </div>
        <p className="text-secondary mb-4">Sistema de Facturación Electrónica en El Salvador</p>
        {/* Contenedor del formulario */}
        <div
          className="w-100 px-4"
          style={{ maxWidth: "400px" }}
        >
          <h2 className="fw-bold text-white mb-4">Iniciar sesión</h2>

          <CForm onSubmit={handleLogin}>
            <div className="mb-3">
              <CFormInput
                type="text"
                id="nit"
                placeholder="NIT"
                value={nit}
                onChange={(e) => setNit(e.target.value)}
                className="bg-transparent text-white border-0 border-bottom rounded-0 border-secondary input-login"
              />
            </div>

            <div className="mb-3">
              <CFormInput
                type="text"
                id="usuario"
                placeholder="Usuario"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                className="bg-transparent text-light border-0 border-bottom rounded-0 border-secondary input-login"
              />
            </div>

            <div className="mb-4">
              <CFormInput
                type="password"
                id="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-transparent text-light border-0 border-bottom rounded-0 border-secondary input-login"
              />
            </div>

            {error && (
              <CAlert color="danger" className="py-2 text-center">
                {error}
              </CAlert>
            )}
            <CButton
              color="light"
              type="submit"
              className="w-100 py-2 fw-semibold rounded-pill"
            >
              Entrar
            </CButton>
          </CForm>

          <div className="text-center mt-4">
            <a href="#" className="text-secondary small text-decoration-none me-3">
              ¿Olvidaste tu contraseña?
            </a>
            <a href="#" className="text-secondary small text-decoration-none">
              Crear cuenta nueva
            </a>
          </div>
        </div>


        {/* Footer */}
        <footer className="text-center text-secondary small mt-5">
          © {new Date().getFullYear()} LOGPOSE
        </footer>
      </div>
    </div>
  );
}
